import { alpha } from "@mui/material";
import type { SxProps, Theme } from "@mui/material/styles";
import type { SystemStyleObject } from "@mui/system";
import { getHeaderBarGradient } from "assets/themes/themeTokens";

export const getHeaderAppBarSx = (theme: Theme): SystemStyleObject<Theme> => ({
  zIndex: theme.zIndex.drawer + 1,
  background: getHeaderBarGradient(theme),
  borderBottom: `1px solid ${alpha(theme.palette.common.white, 0.08)}`,
  color: theme.palette.common.white,
  boxShadow: `0 10px 24px ${alpha(theme.palette.common.black, 0.18)}`,
});

export const headerToolbarSx: SxProps<Theme> = {
  minHeight: "72px !important",
  display: "flex",
  justifyContent: "space-between",
  gap: { xs: 1, md: 2 },
  px: { xs: 1.5, md: 3 },
};

export const getHeaderIconButtonSx = (theme: Theme): SystemStyleObject<Theme> => ({
  border: `1px solid ${alpha(theme.palette.common.white, 0.18)}`,
  backgroundColor: alpha(theme.palette.common.white, 0.08),
});

export const getHeaderActionButtonSx = (theme: Theme, isActive: boolean): SystemStyleObject<Theme> => ({
  minWidth: { xs: 40, sm: "auto" },
  px: { xs: 1, sm: 1.5 },
  py: 0.75,
  borderRadius: 999,
  border: `1px solid ${alpha(theme.palette.common.white, isActive ? 0.24 : 0.18)}`,
  backgroundColor: alpha(theme.palette.common.white, isActive ? 0.18 : 0.08),
  color: theme.palette.common.white,
  textTransform: "none",
  fontWeight: 700,
  "&:hover": {
    backgroundColor: alpha(theme.palette.common.white, isActive ? 0.24 : 0.14),
    borderColor: alpha(theme.palette.common.white, 0.26),
  },
  "& .MuiButton-startIcon": {
    mr: { xs: 0, sm: 0.75 },
    ml: 0,
  },
});

export const getHeaderProfileBadgeSx = (theme: Theme): SystemStyleObject<Theme> => ({
  px: 1.5,
  py: 0.75,
  borderRadius: 999,
  border: `1px solid ${alpha(theme.palette.common.white, 0.16)}`,
  backgroundColor: alpha(theme.palette.common.white, 0.08),
});

export const headerAvatarSx: SxProps<Theme> = {
  width: 34,
  height: 34,
  bgcolor: "primary.main",
};

export const headerProfileNameSx: SxProps<Theme> = {
  display: { xs: "none", sm: "block" },
  maxWidth: 220,
};
